import React, {Component} from 'react'
import {Button, Header, Icon, Input, Modal} from 'semantic-ui-react'

export default class ChangeTrainingTimeModal extends Component {

    state = {};

    setWeekDay = (ev, data) => {
        this.setState({weekDay: data.value});
    };

    setHours = (ev, data) => {
        this.setState({hours: data.value});
    };

    setMinutes = (ev, data) => {
        this.setState({minutes: data.value});
    };

    handleSubmit = () => this.props.changeTrainingTime(
        this.state.weekDay, this.state.hours, this.state.minutes);

    render() {
        return (
            <Modal
                open={this.props.open}
                basic
                size='small'
                closeOnEscape={true}
                closeOnDimmerClick={true}
            >
                <Header icon='users' content='Sett treningstid'/>
                <Modal.Content>
                    <Input icon='beer' placeholder="Ukedag? (Søndag = 0)" onChange={this.setWeekDay}/>
                    <Input icon='beer' placeholder="Time" onChange={this.setHours}/>
                    <Input icon='beer' placeholder="Minutter" onChange={this.setMinutes}/>
                </Modal.Content>
                {this.state.weekDay && this.state.hours && this.state.minutes ?
                    <Modal.Actions>
                        <Button color='red' onClick={this.handleClose} inverted>
                            <Icon name='remove'/>Avbryt
                        </Button>
                        <Button inverted onClick={this.handleSubmit} color='green' content='Stemmer'/>
                    </Modal.Actions> : null}
            </Modal>)
    }
}



// WEBPACK FOOTER //
// ./src/Components/ChangeTrainingTimeModal.js